import React from "react";
import { Prompt, Redirect } from "react-router-dom";
import TextInput from "./common/TextInput";
import DropDown from "./common/DropDown";
import CheckBox from "./common/CheckBox";
import { getRecipes } from "../api/recipes";
import * as Api from "../api/diet";
import { getMacros } from "../api/profile";
import DietFood from "./DietFood";
import { FiRefreshCcw } from "react-icons/fi";
import { toast } from "react-toastify";

class DietGenerator extends React.Component {
    state = {
        fats: 0,
        carbs: 0,
        proteins: 0,

        useRecipes: false,
        bfSelection: 0,
        lunchSelection: 0,
        dinnerSelection: 0,
        supperSelection: 0,
        colSelection: 0,
        col2Selection: 0,
        bfReps: [],
        lunchReps: [],
        dinnerReps: [],
        supperReps: [],
        col1Reps: [],
        col2Reps: [],
        diet: {
            mealQty: 3,
            breakDistribution: false,
            autoAddFood: false,
            name: ""
        },
        showAllData: false,
        preventRedirect: false,
        saved: false
    };

    async componentDidMount() {
        // This binding is necessary to make `this` work in the callback
        this.onGenerateClicked = this.onGenerateClicked.bind(this);
        this.updateDietHandler = this.updateDietHandler.bind(this);
        this.refreshDietHandler = this.refreshDietHandler.bind(this);
        this.saveDietHandler = this.saveDietHandler.bind(this);
        this.handlePropChange = this.handlePropChange.bind(this);
        this.updateValue = this.updateValue.bind(this);
        this.handleDietChange = this.handleDietChange.bind(this);

        await this.checkIfEditing();
        await this.getProfileMacros();
        await this.getRecipeLists();
    }

    async checkIfEditing() {
        const dietId = this.props.match.params.dietId;
        if (dietId) {
            try {
                let editedDiet = await Api.getDiet(dietId);
                this.setState({ diet: editedDiet });
            } catch {
                toast.error("Error al obtener dieta");
            }
        }
    }

    async getProfileMacros() {
        let stats = await getMacros(this.props.user.id);
        if (stats) {
            this.setState({
                fats: stats.fats,
                carbs: stats.carbs,
                proteins: stats.proteins
            });
        }
    }

    async getRecipeLists() {
        let recipes = await getRecipes();
        let bfReps = recipes.filter(recipe => [1, 2, 3].includes(recipe.mealTime));
        let lunchReps = recipes.filter(recipe => [1, 2, 3].includes(recipe.mealTime));
        let dinnerReps = recipes.filter(recipe => [1, 2, 3].includes(recipe.mealTime));
        let supperReps = recipes.filter(recipe => [1, 2, 3].includes(recipe.mealTime));
        let col1Reps = recipes.filter(recipe => [4, 5].includes(recipe.mealTime));
        let col2Reps = recipes.filter(recipe => [4, 5].includes(recipe.mealTime));

        this.setState({
            bfReps: bfReps,
            lunchReps: lunchReps,
            dinnerReps: dinnerReps,
            supperReps: supperReps,
            col1Reps: col1Reps,
            col2Reps: col2Reps,
            bfSelection: bfReps[0].id,
            lunchSelection: lunchReps[0].id,
            dinnerSelection: dinnerReps[0].id,
            supperSelection: supperReps[0].id,
            colSelection: col1Reps[0].id,
            col2Selection: col2Reps[0].id
        });
    }

    onSubmit(event) {
        event.preventDefault();
    }

    async onGenerateClicked(event) {
        let dietPars = {
            UserId: this.props.user.id,
            Stats: {
                Proteins: this.state.proteins,
                Calories: 0,
                Fats: this.state.fats,
                Carbs: this.state.carbs
            },
            MealsQty: this.state.diet.mealQty,
            MealPreference: null,
            FoodPreference: null,
            AutoAddFood: this.state.diet.autoAddFood,
            BreakDistribution: this.state.diet.breakDistribution
        };

        if (this.state.useRecipes) {
            dietPars.MealPreference = [
                { Id: this.state.bfSelection, MealTime: 1 },
                { Id: this.state.lunchSelection, MealTime: 2 },
                { Id: this.state.dinnerSelection, MealTime: 3 }
            ];

            if (this.state.diet.mealQty === 4 || this.state.diet.mealQty === 5) {
                dietPars.MealPreference.push({
                    Id: this.state.supperSelection,
                    MealTime: 6
                });
            }
            if (this.state.diet.mealQty > 4) {
                dietPars.MealPreference.push({
                    Id: this.state.colSelection,
                    MealTime: 4
                });
            }
            if (this.state.diet.mealQty === 7) {
                dietPars.MealPreference.push({
                    Id: this.state.col2Selection,
                    MealTime: 5
                });
            }
        }
        this.getDiet(dietPars);
    }

    updateValue(event, dataType = "", objName = event.target.id, value = event.target.value, isValid = true) {
        this.setState({ [objName]: value, preventRedirect: true });
        if (!isValid)
            toast.error("Numero no valido");
    }

    handleDietChange(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true
    ) {
        if (event.target.id === "breakDistribution")
            value = !value;

        if (dataType === "select")
            value = Number(value);
        const updatedDiet = { ...this.state.diet, [objName]: value };
        this.updateDietHandler(updatedDiet, false);
    }

    handlePropChange(prop, value, refresh = false) {
        const updatedDiet = { ...this.state.diet, [prop]: value };
        this.updateDietHandler(updatedDiet, refresh);
    }

    /**
    * Updates diet with a new updated object
    * @param {Object} diet new diet object
    * @param {Boolean} refresh if an API call is needed to recalculate the unlocked diet values
    */
    async updateDietHandler(diet, refresh = false) {
        await this.setState({ diet: diet, preventRedirect: true }); //awaits setState so refresh get the updated state values
        if (refresh) this.refreshDietHandler();
    }

    async refreshDietHandler(event) {
        let dietPars = {
            UserId: this.props.user.id,
            Stats: {
                Proteins: this.state.proteins,
                Calories: 0,
                Fats: this.state.fats,
                Carbs: this.state.carbs
            },
            MealsQty: this.state.diet.mealQty,
            MealPreference: null,
            FoodPreference: this.state.diet.foodList,
            AutoAddFood: this.state.diet.autoAddFood,
            BreakDistribution: this.state.diet.breakDistribution
        };
        this.getDiet(dietPars);
    }

    isDietValid(diet) {
        let message = undefined;

        if (!diet.name) message = "Falta especificar el nombre de la dieta";
        else {
            for (let i = 0; i < diet.foodList.length; i++) {
                let food = diet.foodList[i];
                if (!food.omit && !food.lockedPortion)
                    if (food.minPortion > food.maxPortion) {
                        message = `El valor minimo de '${food.foodName}' debe ser menor a su maximo`;
                        break;
                    }
            }
        }

        if (message) {
            toast.error(message);
            return false;
        }
        return true;
    }

    async saveDietHandler(event, asNew = false) {
        if (!this.isDietValid(this.state.diet)) {
            return;
        }

        let diet = this.state.diet;
        diet.userId = this.props.user.id;
        diet.mealsControl = null;
        diet.message = null;
        diet.stats = null;
        let oldId = undefined;
        if (asNew) {
            oldId = diet.id;
            diet.id = undefined;
        }
        debugger;
        try {
            if (diet.id) await Api.updateDiet(diet.id, diet);
            else await Api.addDiet(diet);
            this.setState({ preventRedirect: false, saved: true });
            toast.success("Dieta guardada exitosamente");
        } catch (error) {
            if (asNew) diet.id = oldId;
            toast.error("Hubo un error al guardar");
        }
    }

    async getDiet(dietPars) {
        try {
            let genDiet = await Api.generateDiet(dietPars);
            if (!genDiet.isValid) {
                toast.error("No se pud\u00f3 generar una dieta balanceada, sigue alguna de las sugerencias en naranja:", { autoClose: 10000 });
            } else toast.success("Dieta generada exitosamente.");

            genDiet.id = this.state.diet.id;
            genDiet.name = this.state.diet.name;
            genDiet.mealQty = this.state.diet.mealQty;
            genDiet.autoAddFood = this.state.diet.autoAddFood;
            genDiet.breakDistribution = this.state.diet.breakDistribution;

            this.setState({ diet: genDiet });
        } catch (error) {
            toast.error("Hubo un error al obtener la dieta.");
        }
    }

    render() {
        if (this.state.saved) {
            return <Redirect to="/Diets" />;
        } else
            return (
                <>
                    <h2> Diet Generator</h2>
                    <Prompt when={this.state.preventRedirect} message="Estas seguro que deseas abandonar esta pagina sin guardar tus cambios?" />
                    <form onSubmit={this.onSubmit}>
                        <TextInput id="carbs" label="Carbohidratos" dataType="float" value={this.state.carbs} onChange={this.updateValue} />
                        <TextInput id="fats" label="Grasas" dataType="float" value={this.state.fats} onChange={this.updateValue} />
                        <TextInput id="proteins" label="Proteinas" dataType="float" value={this.state.proteins} onChange={this.updateValue} />
                        <br/>
                        <DropDown id="mealQty" label="Numero de comidas" value={this.state.diet.mealQty} onChange={this.handleDietChange} list={[
                            { "id": 3, "text": "3 (breakfast, lunch, dinner)" },
                            { "id": 4, "text": "4 (breakfast, lunch, dinner, supper)" },
                            { "id": 5, "text": "4 meals and 1 collation" },
                            { "id": 6, "text": "3 meals and 1 collation" },
                            { "id": 7, "text": "3 meals and 2 collations" }
                        ]} />
                        <table>
                            <tbody>
                                {!this.state.diet.id && (
                                    <>
                                        <tr>
                                            <td colSpan="2">
                                                <br />
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.useRecipes}
                                                    onChange={event => this.setState({ useRecipes: event.target.checked })}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label"> Usar recetas?</label>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colSpan="2">
                                                <table
                                                    style={{
                                                        display: this.state.useRecipes ? "block" : "none"
                                                    }}
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label>Desayuno:</label>
                                                            </td>
                                                            <td>
                                                                <select
                                                                    onChange={event =>
                                                                        this.setState({
                                                                            bfSelection: parseInt(event.target.value)
                                                                        })
                                                                    }
                                                                >
                                                                    {this.state.bfReps.map(recipe => {
                                                                        return (
                                                                            <option key={recipe.id} value={recipe.id}>
                                                                                {recipe.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label>Comida:</label>
                                                            </td>
                                                            <td>
                                                                <select
                                                                    onChange={event =>
                                                                        this.setState({
                                                                            lunchSelection: parseInt(event.target.value)
                                                                        })
                                                                    }
                                                                >
                                                                    {this.state.lunchReps.map(recipe => {
                                                                        return (
                                                                            <option key={recipe.id} value={recipe.id}>
                                                                                {recipe.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <label>Cena:</label>
                                                            </td>
                                                            <td>
                                                                <select
                                                                    onChange={event =>
                                                                        this.setState({
                                                                            dinnerSelection: parseInt(event.target.value)
                                                                        })
                                                                    }
                                                                >
                                                                    {this.state.dinnerReps.map(recipe => {
                                                                        return (
                                                                            <option key={recipe.id} value={recipe.id}>
                                                                                {recipe.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        {this.state.diet.mealQty === 4 || this.state.diet.mealQty === 5 ? (
                                                            <tr>
                                                                <td>
                                                                    <label>Supper:</label>
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        onChange={event =>
                                                                            this.setState({
                                                                                supperSelection: parseInt(event.target.value)
                                                                            })
                                                                        }
                                                                    >
                                                                        {this.state.supperReps.map(recipe => {
                                                                            return (
                                                                                <option key={recipe.id} value={recipe.id}>
                                                                                    {recipe.name}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr />
                                                        )}
                                                        {this.state.diet.mealQty > 4 ? (
                                                            <tr>
                                                                <td>
                                                                    <label>Collation:</label>
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        onChange={event =>
                                                                            this.setState({
                                                                                colSelection: parseInt(event.target.value)
                                                                            })
                                                                        }
                                                                    >
                                                                        {this.state.col1Reps.map(recipe => {
                                                                            return (
                                                                                <option key={recipe.id} value={recipe.id}>
                                                                                    {recipe.name}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr />
                                                        )}
                                                        {this.state.diet.mealQty === 7 ? (
                                                            <tr>
                                                                <td>
                                                                    <label>Collation 2:</label>
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        onChange={event =>
                                                                            this.setState({
                                                                                col2Selection: parseInt(event.target.value)
                                                                            })
                                                                        }
                                                                    >
                                                                        {this.state.col2Reps.map(recipe => {
                                                                            return (
                                                                                <option key={recipe.id} value={recipe.id}>
                                                                                    {recipe.name}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            <tr />
                                                        )}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td />
                                            <td>
                                                <br />
                                                <button onClick={this.onGenerateClicked} className="btn btn-primary">
                                                    Generate
                                                </button>
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </form>
                    {this.state.diet.foodList && (
                        <>
                            <CheckBox id="breakDistribution" label="Forzar distribucion similar de nutrientes entre todas las comidas" value={!this.state.diet.breakDistribution} onChange={this.handleDietChange} />
                            <CheckBox id="autoAddFood" label="Permitir agregar comida automaticamente si es necesario?" value={this.state.diet.autoAddFood} onChange={this.handleDietChange} />
                            <CheckBox id="showAllData" label="Mostrar informacion completa?" value={this.state.showAllData} onChange={this.updateValue} />
                            {/*<CheckBox id="allowCalsExchange" label="Permitir intercambiar calorias entre grasas y carbohidratos?" value={this.state.allowCalsExchange} onChange={this.updateValue} />*/}
                            <br/>
                            <DietFood
                                diet={this.state.diet}
                                mealQty={this.state.diet.mealQty}
                                updateDiet={this.updateDietHandler}
                                refreshDiet={this.refreshDietHandler}
                                showAllData={this.state.showAllData}
                            />
                            <div className="tip">{this.state.diet.message}</div>
                            <br />
                            <span>Nombre de la dieta: </span>&nbsp;
                            <input
                                type="text"
                                onChange={event => this.handlePropChange("name", event.target.value)}
                                value={this.state.diet.name}
                                required
                            />&nbsp;
                            <button onClick={this.saveDietHandler} className="btn btn-primary">
                                Guardar dieta
                            </button>
                            {this.state.diet.id && (
                                <>
                                    &nbsp;&nbsp;
                                    <button onClick={event => this.saveDietHandler(event, true)} className="btn btn-primary">
                                        Guardar como nueva dieta
                                    </button>
                                </>
                            )}
                            <br />
                            <br />
                        </>
                    )}
                </>
            );
    }
}
export default DietGenerator;
